import React from "react";
import { layout } from "./theme/layout";

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
  return (
    <main
      className="mx-auto w-full"
      style={{ maxWidth: layout.maxW }}
    >
      {props.children}
    </main>
  );
};
